<template>
  <div class="contracSearch_container">
    <div class="contracSearch_search">
      <div class="contracSearch_search_item" style="width:100%">
        <span>{{ $t('title.Test_case') }}:</span>
        <el-select value-key="id" @change="exampleChange" v-model="selectExampleName" :placeholder="this.$t('title.please_choose')">
          <el-option
            v-for="item in exampleOptions"
            :key="item.id"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
        <p style="margin-left:auto">000000000000000000</p>
      </div>
    </div>
    <div class="contracSearch_search">
      <div class="contracSearch_search_item">
        <span>{{ $t('title.environment') }}：</span>
        <el-select style="width: 250px" v-model="selectEnv" @change="changeEnv" :placeholder="this.$t('title.environment')">
          <el-option
            v-for="item in optionEnv"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </div>
      <div class="contracSearch_search_item">
        <span>{{ $t('title.system') }}：</span>
        <el-select style="width: 250px" v-model="selectApp" @change="changeApp" :placeholder="this.$t('title.system')">
          <el-option
            v-for="item in optionsApp"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="contract_list" v-for="(opt, index) in data" :key="index">
      <div class="contracSearch_search">
        <div class="contracSearch_search_item">
          <span>{{ $t('title.contract') }}：</span>
          <el-select 
            style="width: 250px" 
            v-model="opt.userContract" 
            :placeholder="$t('title.please_choose')"
            @change="contractChange(opt.id, $event)"
            value-key="userContractId"
          >
            <el-option
              v-for="item in contractList"
              :key="item.userContractId"
              :label="`${item.rpcServer} - ${item.chainId}链 - ${item.contractName}`"
              :value="item"
            ></el-option>
          </el-select>
        </div>
       <div class="contracSearch_search_item">
          <span>{{ $t('title.Contract_address') }}：</span>
          <el-input
            v-model="opt.contractAddress"
            type="primary"
            style="width: 250px;margin-right:50px;"
          ></el-input>
        </div>
        <div class="contracSearch_search_item">
          <el-button type="primary" icon="el-icon-plus" @click="addContractList" circle></el-button>
          <el-button 
            @click="delContractList(opt.id)" 
            type="danger" 
            icon="el-icon-delete" 
            circle
            v-if="data.length > 1"
          ></el-button>
        </div>
      </div>
      <div class="contract_template_list" v-for="(optChild, index) in opt.childData" :key="index">
        <div style="width:800px;hegiht:1px;border-bottom:1px solid #ccc;margin-bottom:20px" />
        <div class="contracSearch_search">
          <div class="contracSearch_search_item">
            <span>From：</span>
            <el-select
              style="width: 250px;margin-right:30px;"
              v-model="optChild.fromSelectAddress"
              :placeholder="$t('title.please_choose')"
              @change="fromChange(opt.id, optChild.id)"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="`${item.nickname} - ${item.address}`"
                :value="item.address"
              ></el-option>
            </el-select>
            <el-input
              v-model="optChild.fromInputAddress"
              type="primary"
              style="width: 250px"
               :placeholder="$t('title.Please_select_or_enter_Form')"
            ></el-input>
          </div>
          <div
            v-if="(optChild.type && optChild.fromInputAddress) || (optChild.type && !optChild.privateKey)"
            class="contracSearch_search_item"
          >
            <span style="width:50px">{{ $t('title.Private_key') }}：</span>
            <el-input
              v-model="optChild.privateKey"
              type="primary"
              style="width: 250px"
              :placeholder="$t('title.Please_enter_the_private_key')"
            ></el-input>
          </div>
          <div class="contracSearch_search_item">
            <el-button
              type="primary"
              icon="el-icon-plus"
              style="margin-left:20px"
              @click="addContractFnList(opt.id)"
              circle
            ></el-button>
            <el-button
              @click="delContractFnList(opt.id, optChild.id)"
              type="danger"
              icon="el-icon-delete"
              circle
              v-if="opt.childData.length > 1"
            ></el-button>
          </div>
        </div>
         <div class="contracSearch_search">
          <div class="contracSearch_search_item">
            <span>{{ $t('title.Contract_template') }}：</span>
            <span style="width:250px;">
              {{optChild.contractTemplateName}}
            </span>
          </div>
               <div class="contracSearch_search_item">
            <span>{{ $t('title.Contract_method') }}：</span>
            <el-select
              style="width: 250px;"
              v-model="optChild.contractFuncId"
               :placeholder="$t('title.please_choose')"
              @change="contractFnListChange(opt.id, optChild.id)"
              filterable
            >
              <el-option
                v-for="item in optChild.contractFnList"
                :key="item.id"
                :label="item.funcName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div v-if="isValue || optChild.type == 2">
            <label style="display:inline-block;width:80px;">value：</label>
            <el-input
              v-model="optChild.value"
              type="primary"
              style="width: 250px;margin-right:10px;"
              placeholder="value"
            ></el-input>
          </div>
        </div>
           <div class="contracSearch_search">
          <div v-if="optChild.funcParam" style="display:flex;">
            <span style="line-height:40px;">{{ $t('title.Method_entry') }}：</span>
            <div style="margin-left:20px">
              <div
                v-for="(item, index) in optChild.funcParam.split(',')"
                :key="item"
                style="margin-bottom:20px"
              >
                <label style="display:inline-block;width:140px;">{{item.split(':')[1]}}：</label>
                <el-input
                  v-model="optChild.param[index]"
                  type="primary"
                  style="width: 250px;margin-right:10px;"
                  :placeholder="item.split(':')[0]"
                ></el-input>
              </div>
              
            </div>
          </div>
        </div>
        <el-button type="primary" @click="submit(opt.id, optChild.id)">{{ $t('title.Initiate_transaction') }}</el-button>
        <div class="retrun_data">{{optChild.retrunData}}</div>
      </div>
    </div>
 <div class="button-list">
      <div>
        <el-button type="success" @click="opensaveExample">{{ $t('title.Save_the_use_case') }}</el-button>
        <el-button v-if="exampleId" type="danger" @click="updateExample(0)">{{ $t('title.Delete_use_case') }}</el-button>
        <el-button v-if="exampleId" type="primary" @click="updateExample(1)">{{ $t('title.Update_use_case') }}</el-button>
      </div>
      <div>
        <el-button type="primary" @click="refreshData">{{ $t('title.Refresh') }}</el-button>
      </div>
    </div>
    <el-dialog :title="type == 'save' ? $t('title.Save_the_use_case'): $t('title.Update_use_case')" :visible.sync="dialogVisible" width="30%">
      <div style="display:flex;align-items:center;">
        <span style="width:100px">{{ $t('title.Use_case_name') }}:</span>
        <el-input v-model="exampleName" :placeholder="$t('title.Please_enter_the_use_case_name')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('title.Cancel') }}</el-button>
        <el-button type="primary" @click="submitExample">{{ $t('title.Sure') }}</el-button>
      </span>
    </el-dialog>
    <div class="con_table">
      <el-table
        :data="tableData"
        border
        height="520"
        style="width: 100%;margin-bottom: 30px;margin-top: 40px"
        :header-cell-style="this.tableHeaderColor"
      >
        <el-table-column :label="this.$t('title.Serial_number')"  align="center" width="90">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="hash" width="400" align="center">
          <template slot-scope="scope">
           <el-link
              @click="$refs.searchHash.open(scope.row.hash, scope.row.rpcServer, scope.row.fromChainId)"
              :underline="false"
              type="primary"
            >{{scope.row.hash}}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.RPC_service')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rpcServer}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromChainId}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Transfer_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Payee_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.toAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.toAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_payment')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_receipt')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.XTO_quantity')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.coins}}</span>
          </template>
        </el-table-column>
        <el-table-column  :label="this.$t('title.Gas_fee')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gasFee}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Creation_time')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.state')" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.status==-1? $t('title.Sent_awaiting_verification') :scope.row.status==-1? $t('title.failure') : $t('title.success') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
       <!-- 交易查询结果 -->
       <SearchHash ref="searchHash" />
     
    </div>
  </div>
</template>
<script>
import {
  contractList,
  userlList,
  getContractFnList,
  contractTransfer,
  getenvList,
  getappList,
  getcontractList,
  transferList,
  saveContractCase,
  getContractCase,
  updateContractCase,
} from "@/api/interface";
import _ from "lodash";
import SearchHash from '../../SearchHash'
export default {
  components: { SearchHash },
  data() {
    return {
      optionRpc: [],
      optionsChain: [],
      optionConTem: [],
      selectEnv: 0,
      optionEnv: [],
      selectApp: 0,
      optionsApp: [],
      userList: [],
      contractList: [],
      tableData: [],
      data: [
        {
          id: 0,
          userContract: {},
          contractAddress: "",
          childData: [
            {
              id: 0,
              fromSelectAddress: "",
              fromInputAddress: "",
              privateKey: "",
              contractId: "",
              contractTemplateName: '',
              contractFuncId: "",
              funcParam: "",
              param: [],
              retrunData: "",
              contractFnList: [],
              type: 0,
              value: '',
            }
          ]
        }
      ],
      dialogVisible: false,
      exampleName: "",
      exampleOptions: [],
      selectExampleName: "",
      exampleId: "",
      type: "",
      status: "",
      hahsDialogVisible: false,
      returnHash: '',
      isValue: 0,
      currentPage: 1,
      total: 0,
    };
  },
  
  created() {
    this.getData();
    this.getUsers();
    this.getTableData();
    //获取用例列表
    this.getContractCaseList();
  },
  methods: {
    async getData() {
      //获取环境
      await getenvList().then(response => {
        this.optionEnv = response.data;
        this.selectEnv = this.optionEnv[0].code;
      });
      //获取系统
      await getappList().then(response => {
        this.optionsApp = response.data;
        this.selectApp = this.optionsApp[0].code;
      });
      this.getcontractLists();
      //获取合约模板
      contractList().then(response => {
        this.optionConTem = response.data;
        this.data.forEach(v => {
          v.childData.forEach(item => {
            item.contractId = this.optionConTem[0].id;
            item.contractTemplateName = this.optionConTem[0].name;
          });
        });

        this.getContractFnLists(0, response.data[0].id);
      });
    },
    //获取用户列表
    getUsers() {
      let data = {
        userContractId: "",
        address: "",
        page: 1,
        rows: 100000
      };
      userlList(data).then(response => {
        if (response.code == 200) {
          this.userList = response.data.data;

          this.data.forEach(v => {
            v.childData.forEach(item => {
              item.fromSelectAddress = this.userList[0].address;
              item.privateKey = this.userList[0].privateKey
            });
          });
        
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    //获取合约列表
    getcontractLists() {
      let data = {
        env: this.selectEnv,
        app: this.selectApp
      };
      getcontractList(data).then(response => {
        if (response.code == 200) {
          this.contractList = response.data;
          this.data.forEach(v => {
            v.userContract = this.contractList[0]
          });
        } else {
          this.contractList = [];
          this.$message.error(response.msg);
        }
      });
    },
    //获取合约方法列表
    getContractFnLists(parentId = 0, contractId) {
      getContractFnList({ contractId }).then(res => {
        this.data.forEach(v => {
          if (v.id == parentId) {
            v.childData.forEach(item => {
              item.contractFnList = res.data;
              item.funcParam = _.get(res.data[0], "funcParam", "");
              item.contractFuncId = _.get(res.data[0], "id", "");
              item.type = _.get(res.data[0], "type", "");
            });
          }
        });
      });
    },
    getTableData() {
      let data = {
        type: "201",
        page: this.currentPage,
        rows: 10
      };
      transferList(data).then(response => {
        if (response.code == 200) {
          this.tableData = response.data.data;
          this.total = response.data.total
        } else {
          this.tableData = [];
        }
      });
    },
    //获取测试用例列表
    getContractCaseList() {
      getContractCase().then(res => {
        this.exampleOptions = res.data;
      });
    },

    addContractList() {
      const contractId =   this.optionConTem[0].id
      const contractTemplateName = this.optionConTem[0].name
      const userContract = this.data[0].userContract
      const contractFnList = this.data[0].childData[0].contractFnList
      this.data.push({
        id: Date.now(),
        userContract,
        contractAddress: "",
        childData: [
          {
            id: 0,
            fromSelectAddress: "",
            fromInputAddress: "",
            privateKey: "",
            contractId,
            contractTemplateName,
            contractFuncId: "",
            funcParam: "",
            param: [],
            retrunData: "",
            contractFnList,
            type: 0,
            value: '',
          }
        ]
      });
    },
    delContractList(id) {
      this.data = this.data.filter(v => v.id != id);
    },
    addContractFnList(id) { 
      this.data.forEach(v => {
        if (v.id == id) {
          v.childData.push({
            id: Date.now(),
            fromSelectAddress: "",
            fromInputAddress: "",
            privateKey: "",
            contractId: v.childData[0].contractId,
            contractTemplateName: v.childData[0].contractTemplateName,
            contractFuncId: "",
            funcParam: "",
            param: [],
            retrunData: "",
            contractFnList: v.childData[0].contractFnList,
            type: 0,
            value: '',
          });
        }
      });
    },
    delContractFnList(parentId, childId) {
      console.log(parentId, childId);
      this.data.forEach(v => {
        if (v.id == parentId) {
          v.childData = v.childData.filter(item => item.id != childId);
        }
      });
    },
    //环境切换时
    changeEnv() {
      console.log(this.selectEnv, 111111);
      this.getcontractLists();
    },
    //系统切换时
    changeApp() {
      console.log(this.selectApp, 111111);
      this.getcontractLists();
    },
    //地址切换时
    fromChange(parentId, childId) {
      this.data.forEach(v => {
        if (v.id == parentId) {
          v.childData.forEach(item => {
            if (item.id == childId) {
              const opt = this.userList.find(
                v => v.address == item.fromSelectAddress
              );
              item.privateKey = opt.privateKey;
            }
          });
        }
      });
    },
    //合约切换时(当前合约下选中的模板)
    contractChange(id, evt) {
      console.log(evt, this.optionConTem)
      const contractTemplateName = this.optionConTem.find(v => v.id == evt.contractTemplateId).name
      this.data.forEach(v => {
        if(v.id == id) {
          v.childData.forEach(chidItem => {
            chidItem.contractId = evt.contractTemplateId
            chidItem.contractTemplateName = contractTemplateName
          })
        }
      })
      this.getContractFnLists(id, evt.contractTemplateId);
    },
    //合约方法切换时
    contractFnListChange(parentId, childId) {
      this.data.forEach(v => {
        if (v.id == parentId) {
          v.childData.forEach(item => {
            if (item.id == childId) {
              item.contractFnList.forEach(opt => {
                if (opt.id == item.contractFuncId) {
                  console.log(opt.type, 9000000)
                  if(opt.type == 'contractDeposit') {
                    this.isValue = 1
                  } else {
                    this.isValue = 0
                    item.value = ''
                  }
                  item.funcParam = opt.funcParam;
                  item.type = opt.type;
                }
              });
            }
          });
        }
      });
    },
    submit(parentId, childId) {
      const parentData = this.data.find(v => v.id == parentId);
      const childData = parentData.childData.find(v => v.id == childId);
      let privateKey = childData.privateKey
      //如果输入私钥带有0x自动去掉0x
      if(childData.privateKey.substr(0,2) == '0x') {
       privateKey = childData.privateKey.substr(2)
      }
      const data = {
        userContractId: parentData.userContract.userContractId,
        contractAddress: parentData.contractAddress,
        fromAddress: "",
        privateKey: privateKey,
        param: {},
        contractFuncId: childData.contractFuncId,
        value: childData.value
      };
      //地址可选可输入
      if (childData.fromInputAddress) {
        data.fromAddress = childData.fromInputAddress;
      } else {
        data.fromAddress = childData.fromSelectAddress;
      }
      //转换合约方法入参
      const arr = childData.funcParam.split(",");
      for (let i = 0; i < arr.length; i++) {
        data.param[arr[i].split(":")[1]] = childData.param[i];
      }
      data.param = JSON.stringify(data.param);
      contractTransfer(data).then(res => {
        if (res.code == 200) {
          this.$message.success("交易成功");
          this.data.forEach(v => {
            if (v.id == parentId) {
              v.childData.forEach(item => {
                if (item.id == childId) {
                  item.retrunData = res.data;
                }
              });
            }
          });
          this.getTableData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //切换用例
    exampleChange(e) {
      this.data = JSON.parse(e.content);
      console.log(JSON.parse(e.content), 9949494994)
      this.exampleId = e.id;
      this.exampleName = e.name
    },
    opensaveExample() {
      this.dialogVisible = true;
      this.type = "save";
    },
    //提交用例
    submitExample() {
      this.dialogVisible = false;
      //保存
      if ((this.type == "save")) {
        const data = {
          name: this.exampleName,
          content: JSON.stringify(this.data)
        };
        saveContractCase(data).then(res => {
          this.$message.success(res.msg);
          this.getContractCaseList();
        });
        //修改
      } else {
        const data = {
          id: this.exampleId,
          status: this.status,
          name: this.exampleName,
          content: JSON.stringify(this.data)
        };
        updateContractCase(data).then(res => {
          this.$message.success(res.msg);
          this.getContractCaseList();
        });
      }
    },
    //修改或删除
    updateExample(status) {
      this.type = "update";
      this.status = status;
      if (status != 0) {
        this.dialogVisible = true;
      } else {
        //删除不用弹框直接删除
        const data = {
          id: this.exampleId,
          status: this.status,
          content: JSON.stringify(this.data)
        };
        updateContractCase(data).then(res => {
          this.$message.success(res.msg);
          this.getContractCaseList();
        });
      }
    },
    currentPageChange(e) {
      this.currentPage = e;
     this.getTableData()
    },
    refreshData() {
      this.currentPage = 1
      this.getTableData()
    }
  }
};
</script>
<style lang="scss" scoped>
.contracSearch_container {
  padding: 20px 30px;
  .contract_list {
    padding-bottom: 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid #ccc;
  }
  .retrun_data {
    margin-bottom: 30px;
  }
  .contracSearch_search {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .contracSearch_search_item {
      display: flex;
      align-items: center;
      margin-right: 30px;
      span {
        width: 100px;
        display: inline-block;
      }
      p {
        margin-left: 30px;
      }
    }
  }
  .button-list {
    display: flex;
    justify-content: space-between;
  }
}
</style>